var scorm12Obj = (function () {
    "use strict";

    var api, dmeList, utilsInstance, scorm12Obj = {};

    scorm12Obj.getRuntimeData = function() {
        return dmeList;
    };

    scorm12Obj.set = function(key, value) {
        api.LMSSetValue(key, value);
    };

    scorm12Obj.commit = function() {
        api.LMSCommit("");
    };

    scorm12Obj.finish = function() {
        api.LMSCommit("");
        api.LMSFinish("");
        // TODO Should we do this?  Maybe this should be a custom option?
        document.location.href = "blank.htm";
    };

    scorm12Obj.loadDataFromLMS = function () {
        var n, ret, qArray, w, h, i, parsed, lic = '', scoUrl;
        api = getAPIHandle();

        if (!api) {
            alert("LMS API Adapter for SCORM 1.2 could not be located. There is no communication with the LMS therefor no content will be fetched from the content server.");
            return;
        }

        n = api.LMSInitialize("");
        if (n !== "true") {
            alert("LMS Initialize failed.");
            return;
        }
        dmeList = {};
        dmeList["cmi.core._children"] = "";
        dmeList["cmi.core.student_id"] = "";
        dmeList["cmi.core.student_name"] = "";
        dmeList["cmi.core.lesson_location"] = "";
        dmeList["cmi.core.credit"] = "";
        dmeList["cmi.core.lesson_status"] = "";
        dmeList["cmi.core.entry"] = "";
        dmeList["cmi.core.total_time"] = "";
        dmeList["cmi.core.lesson_mode"] = "";

        dmeList["cmi.suspend_data"] = "";
        dmeList["cmi.launch_data"] = "";
        dmeList["cmi.comments"] = "";
        dmeList["cmi.comments_from_lms"] = "";

        //score
        dmeList["cmi.core.score._children"] = "";
        dmeList["cmi.core.score.raw"] = "";
        dmeList["cmi.core.score.min"] = "";
        dmeList["cmi.core.score.max"] = "";

        //student data
        dmeList["cmi.student_data._children"] = "";
        dmeList["cmi.student_data.mastery_score"] = "";
        dmeList["cmi.student_data.max_time_allowed"] = "";
        dmeList["cmi.student_data.time_limit_action"] = "";

        //student preference
        dmeList["cmi.student_preference._children"] = "";
        dmeList["cmi.student_preference.audio"] = "";
        dmeList["cmi.student_preference.language"] = "";
        dmeList["cmi.student_preference.speed"] = "";
        dmeList["cmi.student_preference.text"] = "";

        //objectives
        dmeList["cmi.objectives._children"] = "";
        dmeList["cmi.objectives._count"] = "";

        //interactions
        dmeList["cmi.interactions._children"] = "";
        dmeList["cmi.interactions._count"] = "";

        for (i in dmeList) {
            ret = api.LMSGetValue(i);
            dmeList[i] = ret;
        }
        dmeList.objectives = [];
        dmeList.interactions = [];
        scorm12Obj.getObjectiveData();
        scorm12Obj.getInteractionData();
        scorm12Obj.setupDefaults();
    };

    scorm12Obj.setupDefaults = function () {
        if (s4xdmConfig.forceStatusIncompleteOnInit) {
            var cs = dmeList["cmi.core.lesson_status"];
            if (!cs || cs === "not attempted") {
                dmeList["cmi.core.lesson_status"] = "incomplete";
                api.LMSSetValue("cmi.core.lesson_status", "incomplete");
            }
        }
    };

    scorm12Obj.getObjectiveData = function () {
        if (!s4xdmConfig.useObjectives) {
            return;
        }
        var i = -1, j, ret, obj_names = [];
        obj_names[0] = "id";
        obj_names[1] = "score._children";
        obj_names[2] = "score.raw";
        obj_names[3] = "score.min";
        obj_names[4] = "score.max";
        obj_names[5] = "status";
        var _nameCount = "cmi.objectives._count";
        var nCount = parseInt(api.LMSGetValue(_nameCount));

        var _name = "";
        var _value = "";
        if (!isNaN(nCount)) {
            for (i = nCount - 1; i >= 0; i--) { //walk backward in case LMS does journaling
                for (j = 0; j < obj_names.length; j++) {
                    _name = "cmi.objectives." + i + "." + obj_names[j];
                    _value = api.LMSGetValue(_name);
                    dmeList[_name] = _value;
                }
            }
            //add the _count
            dmeList[_nameCount] = nCount;
        }
        else {
            //add the _count
            dmeList[_nameCount] = "0";
        }

    };

    scorm12Obj.getInteractionData = function () {
        if (!s4xdmConfig.useInteractions) {
            return;
        }
        var i = -1, j, ret, interaction_names = [];
        var _name = "";
        var _value = "";
        interaction_names[0] = "objectives._count";
        interaction_names[1] = "correct_responses._count";

        var _nameCount = "cmi.interactions._count";
        var nCount = parseInt(api.LMSGetValue(_nameCount));
        if (!isNaN(nCount)) {
            for (i = nCount - 1; i >= 0; i--) { //walk backward in case LMS does journaling
                for (j = 0; j < interaction_names.length; j++) {
                    _name = "cmi.interactions." + i + "." + interaction_names[j];
                    _value = api.LMSGetValue(_name);
                    dmeList[_name] = _value;
                }
            }
            //add the _count
            dmeList[_nameCount] = nCount;
        }
        else {
            //add the _count
            dmeList[_nameCount] = "0";
        }
    };


    var _Debug = false;  // set this to false to turn debugging off
                         // and get rid of those annoying alert boxes.

// local variable definitions
    var apiHandle = null;
    var API = null;
    var findAPITries = 0;

    var SCORM_objAPI = null;

    /******************************************************************************
     **
     ** Function getAPIHandle()
     ** Inputs:  None
     ** Return:  value contained by APIHandle
     **
     ** Description:
     ** Returns the handle to API object if it was previously set,
     ** otherwise it returns null
     **
     *******************************************************************************/
    function WriteToDebug(a) {
        //alert(a)
    }

    function SCORM_GrabAPI() {

        WriteToDebug("In SCORM_GrabAPI");

        //if we haven't already located the API, find it using our algorithm
        if (typeof(SCORM_objAPI) == "undefined" || SCORM_objAPI == null) {
            WriteToDebug("Searching with Rustici Software algorithm");
            SCORM_objAPI = SCORM_SearchForAPI(window);
        }

        //if it's still not found, try the algorithm from the SCORM spec
        if (typeof(SCORM_objAPI) == "undefined" || SCORM_objAPI == null) {
            WriteToDebug("Searching with ADL algorithm");
            SCORM_objAPI = SCORM_getAPI();
        }

        WriteToDebug("API Found, returning");

        return SCORM_objAPI;

    }

    function SCORM_SearchForAPI(wndLookIn) {

        WriteToDebug("SCORM_SearchForAPI");

        var objAPITemp = null;
        var strDebugID = "";

        strDebugID = "Name=" + wndLookIn.name + ", href=" + wndLookIn.location.href

        objAPITemp = wndLookIn.API;

        if (SCORM_APIFound(objAPITemp)) {
            WriteToDebug("Found API in this window - " + strDebugID);
            return objAPITemp;
        }

        if (SCORM_WindowHasParent(wndLookIn)) {
            WriteToDebug("Searching Parent - " + strDebugID);
            objAPITemp = SCORM_SearchForAPI(wndLookIn.parent);
        }

        if (SCORM_APIFound(objAPITemp)) {
            WriteToDebug("Found API in a parent - " + strDebugID);
            return objAPITemp;
        }

        if (SCORM_WindowHasOpener(wndLookIn)) {
            WriteToDebug("Searching Opener - " + strDebugID);
            objAPITemp = SCORM_SearchForAPI(wndLookIn.opener);
        }

        if (SCORM_APIFound(objAPITemp)) {
            WriteToDebug("Found API in an opener - " + strDebugID);
            return objAPITemp;
        }

        //look in child frames individually, don't call this function recursively
        //on them to prevent an infinite loop when it looks back up to the parents
        WriteToDebug("Looking in children - " + strDebugID);
        objAPITemp = SCORM_LookInChildren(wndLookIn);

        if (SCORM_APIFound(objAPITemp)) {
            WriteToDebug("Found API in Children - " + strDebugID);
            return objAPITemp;
        }

        WriteToDebug("Didn't find API in this window - " + strDebugID);
        return null;
    }

    function SCORM_LookInChildren(wnd) {

        WriteToDebug("SCORM_LookInChildren");

        var objAPITemp = null;

        var strDebugID = "";

        strDebugID = "Name=" + wnd.name + ", href=" + wnd.location.href

        for (var i = 0; i < wnd.frames.length; i++) {

            WriteToDebug("Looking in child frame " + i);
            objAPITemp = win.frames[i].API;

            if (SCORM_APIFound(objAPITemp)) {
                WriteToDebug("Found API in child frame of " + strDebugID);
                return objAPITemp;
            }

            WriteToDebug("Looking in this child's children " + strDebugID);
            objAPITemp = SCORM_LookInChildren(wnd.frames[i]);

            if (SCORM_APIFound(objAPITemp)) {
                WriteToDebug("API found in this child's children " + strDebugID);
                return objAPITemp;
            }
        }

        return null;
    }

    function SCORM_WindowHasOpener(wnd) {
        WriteToDebug("In SCORM_WindowHasOpener");
        if ((wnd.opener != null) && (wnd.opener != wnd) && (typeof(wnd.opener) != "undefined")) {
            WriteToDebug("Window Does Have Opener");
            return true;
        }
        else {
            WriteToDebug("Window Does Not Have Opener");
            return false;
        }
    }

    function SCORM_WindowHasParent(wnd) {
        WriteToDebug("In SCORM_WindowHasParent");
        if ((wnd.parent != null) && (wnd.parent != wnd) && (typeof(wnd.parent) != "undefined")) {
            WriteToDebug("Window Does Have Parent");
            return true;
        }
        else {
            WriteToDebug("Window Does Not Have Parent");
            return false;
        }
    }

    function SCORM_APIFound(obj) {
        WriteToDebug("In SCORM_APIFound");
        if (obj == null || typeof(obj) == "undefined") {
            WriteToDebug("API NOT Found");
            return false;
        }
        else {
            WriteToDebug("API Found");
            return true;
        }
    }

    var SCORM_findAPITries = 0;

    function SCORM_findAPI(win) {
        WriteToDebug("In SCORM_findAPI");
        // Check to see if the window (win) contains the API
        // if the window (win) does not contain the API and
        // the window (win) has a parent window and the parent window
        // is not the same as the window (win)
        while (( win.API == null) && (win.parent != null) && (win.parent != win)) {
            // increment the number of findAPITries
            SCORM_findAPITries++;
            WriteToDebug("SCORM_findAPITries=" + SCORM_findAPITries);
            // Note: 7 is an arbitrary number, but should be more than sufficient
            if (SCORM_findAPITries > 7) {
                WriteToDebug("Error finding API -- too deeply nested.");
                //set it back to 0
                SCORM_findAPITries = 0;
                return null;
            }

            // set the variable that represents the window being
            // being searched to be the parent of the current window
            // then search for the API again
            win = win.parent;
        }
        return win.API;
    }

    function getAPIHandle() {
        WriteToDebug("In SCORM_getAPI");

        // start by looking for the API in the current window
        var theAPI = SCORM_findAPI(window);
        // if the API is null (could not be found in the current window)
        // and the current window has an opener window

        //we have to use parent.window.opener here because the APIWraper is in the nav.htm file and we need to get up to the parent to check for the opener window
        if ((theAPI == null) && (parent.window.opener != null) && (typeof(parent.window.opener) != "undefined")) {
            WriteToDebug("Looking in opener");
            // try to find the API in the current windows opener
            theAPI = SCORM_findAPI(parent.window.opener);
        }
        // if the API has not been found

        if (theAPI == null) {
            // Alert the user that the API Adapter could not be found
            WriteToDebug("Unable to find an API adapter");
        }
        return theAPI;
    }

    return scorm12Obj;

})();
